"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const InputGroup = (props) => {
    return (0, jsx_runtime_1.jsx)("div", { className: 'p-inputgroup flex-1', children: props.children });
};
exports.InputGroup = InputGroup;
